export default {"src":"/_next/static/media/enjoy-view.d3961841.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};